<router-outlet></router-outlet>
<app-mds-components></app-mds-components>